import React from "react";
import { useGetRecordByIdQuery, useUpdateCoachApplicationStatusMutation } from "../../coach-recordings.service";
import { getLangNameByLangCode } from "src/utils/util";
import { StatusBadge } from "./status-badge";
import { ScriptViewer } from "./record-script";
import { AudioPlayer } from "./audio-player";
import { ActionButtons } from "./actions";

type CoachRecordInfoProps = {
  id: string;
};

export const CoachRecordInfo: React.FC<CoachRecordInfoProps> = ({ id }) => {
  const { data: record, isLoading, isSuccess } = useGetRecordByIdQuery(id);

  return isSuccess ? (
    <div>
      <div className="text-center mb-6">
        <h2 className="text-2xl font-semibold">🎙️ Coach Recording Review</h2>
        <p className="text-sm text-gray-500">Review the coach's recording.</p>
      </div>

      <div className="space-y-4">
        <div className="flex justify-between">
          <span className="font-medium">🌐 Language:</span>
          <span>{getLangNameByLangCode(record.langCode)}</span>
        </div>

        <div className="flex justify-between">
          <span className="font-medium">📧 Email:</span>
          {record.email ? (
            <a href={`mailto:${record.email}`} className="text-blue-600 underline">
              {record.email}
            </a>
          ) : (
            "—"
          )}
        </div>

        <div className="flex justify-between items-center">
          <span className="font-medium">📊 Status:</span>
          <StatusBadge status={record.manualReviewStatus} />
        </div>

        <ScriptViewer script={record.scriptToRead} />

        {record.recordingUrl ? <AudioPlayer url={record.recordingUrl} /> : null}
        {!record.recordingUrl && <div className="text-center mt-4 text-sm text-red-600">⚠️ File not found</div>}

        <ActionButtons record={record} />
      </div>
    </div>
  ) : (
    <div>Loading…</div>
  );
};
